/**
 * Initialize Swiper sliders
 * Performance: Early exits, shared config objects
 */
function swiperInit() {
  if (typeof Swiper === "undefined") {
    return;
  }

  // Shared navigation config (reused across sliders)
  const navConfig = {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  };

  // Slider 1: vz-post-series-slider
  const postSeriesSlider = document.querySelector(".vz-post-series-slider");
  if (postSeriesSlider && postSeriesSlider.querySelector(".swiper-wrapper")) {
    new Swiper(postSeriesSlider, {
      speed: 350,
      slidesPerView: 4,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 960px
        860: {
          slidesPerView: 3,
          slidesPerGroup: 2,
          spaceBetween: 40,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 2,
          spaceBetween: 40,
        },
      },
      autoplay: false,
      watchOverflow: true,
      navigation: navConfig,
    });
  }

  // Slider 2: vz-post-series-slider-two
  const postSeriesSliderTwo = document.querySelector(".vz-post-series-slider-two");
  if (postSeriesSliderTwo && postSeriesSliderTwo.querySelector(".swiper-wrapper")) {
    new Swiper(postSeriesSliderTwo, {
      speed: 350,
      slidesPerView: 2,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 960px
        860: {
          spaceBetween: 40,
        },
      },
      autoplay: false,
      watchOverflow: true,
      navigation: navConfig,
    });
  }

  // Slider 3: vz-post-series-slider-three
  const postSeriesSliderThree = document.querySelector('.vz-post-series-slider-three');
  if (postSeriesSliderThree && postSeriesSliderThree.querySelector('.swiper-wrapper')) {
    new Swiper(postSeriesSliderThree, {
      speed: 350,
      slidesPerView: 3,

    // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 960px
        860: {
          slidesPerView: 3,
          slidesPerGroup: 2,
          spaceBetween: 40,
        },
      },
      autoplay: false,
      watchOverflow: true,
      navigation: navConfig,
    });
  }

  // Slider 4: vz-frontpage-slider
  const frontpageSlider = document.querySelector('.vz-frontpage-slider');
  if (frontpageSlider && frontpageSlider.querySelector('.swiper-wrapper')) {
    new Swiper(frontpageSlider, {
      autoplay: {
        delay: 8000,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      speed: 700,
      spaceBetween: 100,
      slidesPerView: 1,
      watchOverflow: true,
      loop: true,
      renderBullet: function(index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
    });
  }

  // Update lazy loading if available
  if (typeof vzLazyLoadUpdate === 'function') {
    vzLazyLoadUpdate();
  }
}
